import { Button } from '@shopify/polaris';
import React  from 'react';
import ShopifyModal from "../../../../components/ShopifyModal";

const DowngradePlanModal = ({downgradeReminde,setDowngradeReminde,handleMageUpgrade,setPremiumData})=> {
    const handleContactSupport = ()=>{
        let sendMsg = `Hi! I'd like some help changing from an annual to a monthly plan.`

        try {
            // 填充信息并激活对话弹窗
            // window.Intercom('showNewMessage', sendMsg)
            window.Willdesk.show();
            window.Willdesk.chat(sendMsg);
        } catch (error) {
            console.info(error)
        }
    }
    const handleClose = ()=>{
        setDowngradeReminde((prev)=>({
            ...prev,
            open:false
        }))
    }
      // 时间格式
  function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000 + 8 * 3600 * 1000);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const year = date.getUTCFullYear();
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();

    return `${month} ${day}, ${year}`;
  }
    const nextTime = ()=>{
        let time = '';
        if (downgradeReminde.bill_next_time !== 0) {
            time = formatTimestamp(downgradeReminde.bill_next_time)
        }
        return time
    }
    const currentPlan = ()=>{
        let text = 'Basic';
        if (downgradeReminde.plan === 1) {
            text = 'Pro';
        }
        if (downgradeReminde.plan === 2) {
            text = 'Plus';
        }
        if (downgradeReminde.plan === 4) {
            text = 'Basic';
        }
        if (downgradeReminde.plan === 5) {
            text = 'Premium';
        }
        return text;
    }
    return (
        <div>
            <ShopifyModal
            id="downgrade-plan-modal"
            open={downgradeReminde.open}
            onClose={handleClose}
            heading="Downgrade Reminder"
            primaryAction={{
                content: 'Downgrade',
                onAction: () => {
                    if (downgradeReminde.needDown === 5) {
                        setPremiumData((prevValue) => ({
                        ...prevValue,
                        open: true,
                        }));
                    }else {
                        handleMageUpgrade(downgradeReminde.needDown)
                    }
                    handleClose()
                },
            }}
            secondaryActions={{
                content: 'Cancel',
                onAction: () => {
                    handleClose()
                },
            }}
            >
                    {downgradeReminde.isHeight ? <p>Your subscription will transition to the new plan on <strong>{nextTime()}</strong>, when your current {currentPlan()} plan expires. Please note that upon downgrade, you will no longer have access to {currentPlan()}-exclusive features and capabilities.
                    </p>:
                    <div>
                        <p>
                        Your subscription will transition to the new plan on <strong>{nextTime()}</strong>, when your current plan expires.
                        </p>
                        <p style={{margin:'4px 0'}}>
                        Please note that switching from an annual to a monthly subscription is considered a plan downgrade in Shopify's billing system and can only be processed after your current annual term ends.
                        </p>
                        <p>
                        You have two options:
                        </p>
                        <ul style={{paddingLeft:'0',margin:0}}>
                            <li>
                            ● Upgrade to a higher-tier annual plan with prorated charges based on your remaining billing period
                            </li>
                            <li>
                            ● <Button variant='plain' onClick={()=>handleContactSupport()}>Contact our support team</Button> for personalized assistance with your subscription changes
                            </li>
                        </ul>
                    </div>}
            </ShopifyModal>
        </div>
    );
}

export default DowngradePlanModal;
